import type { InnogyComponentRendering } from '@core/jss-models';
import type {
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@sitecore-jss/sitecore-jss-angular';

export enum HERO_TYPES {
  HERO = 'Hero',
  HERO_MINIMAL = 'HeroMinimal',
  HERO_WITH_WIDGET = 'HeroWithWidget',
  HERO_WITH_APP_BUTTONS = 'HeroWithAppButtons',
  HERO_WITH_ASSET = 'HeroWithAsset',
}

export enum HERO_FIELDS {
  ANDROID_BUTTON = 'androidButton',
  BACKGROUND_IMAGE = 'backgroundImage',
  BOTTOM_IMAGE = 'bottomImage',
  HEADING_LINE1 = 'headingLine1',
  HEADING_LINE2 = 'headingLine2',
  IOS_BUTTON = 'iosButton',
  MAIN_IMAGE = 'mainImage',
  PARAGRAPH = 'paragraph',
  PRIMARY_BUTTON = 'primaryButton',
  RICH_TEXT = 'richText',
  SECONDARY_BUTTON = 'secondaryButton',
  WIDGET = 'widget',
}

export type Hero = {
  headingLine1: TextField;
  headingLine2?: TextField;
  primaryButton?: LinkField;
  secondaryButton?: LinkField;
  androidButton?: TextField;
  iosButton?: TextField;
  backgroundImage?: ImageField;
  mainImage?: ImageField;
  bottomImage?: ImageField;
  paragraph?: TextField;
  richText?: RichTextField;
  widget?: InnogyComponentRendering;
};

export type HeroAppButton = {
  alt: string;
  type: 'ios-app-store' | 'google-play-store';
  src: string;
  url: string;
};
